<template>
  <div>
    <ul>
      <li v-for="(media, index) of mediaList" :key="'file_' + index">
        {{ media.title }}

        <a target="_blank" :href="downloadUrl(media.id)">Pobierz</a>

        <check-permission permissions="MEDIA.DELETE">
          <a class="ml-2" href="#" @click.prevent="$emit('delete', media)">Usuń</a>
        </check-permission>
      </li>
    </ul>
  </div>
</template>

<script>
import { mediaMixin } from '@/mixins/media';

// @vuese
// Lista plików
// @group Media
export default {
  mixins: [mediaMixin],
  props: {
    // Lista plików
    mediaList: { type: Array, required: true }
  }
};
</script>
